(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-blog-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class YGBlogV1 extends HTMLElement {
      connectedCallback() {
        this.formatNumbers();
      }

      formatNumbers() {
        const locale = document.documentElement.lang || navigator.language || 'en-US';
        const formatter = new Intl.NumberFormat(locale);

        this.querySelectorAll('[data-yg-number]').forEach((node) => {
          const value = Number(node.getAttribute('data-yg-number'));

          if (!Number.isNaN(value)) {
            node.textContent = formatter.format(value);
          }
        });
      }
    }

    const boot = () => {
      if (!window.customElements.get('yg-blog-v1')) {
        window.customElements.define('yg-blog-v1', YGBlogV1);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-dot-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('yg-image-dot-product')) {
      return;
    }

    class YGImageDotProduct extends HTMLElement {
      connectedCallback() {
        this.handleResize = () => this.positionActiveCards();

        this.addEventListener('click', (event) => {
          const previousButton = event.target.closest('[data-yg-image-dot-prev]');
          const nextButton = event.target.closest('[data-yg-image-dot-next]');

          if (previousButton || nextButton) {
            this.changeSlide(previousButton ? -1 : 1);
            return;
          }

          const trigger = event.target.closest('[data-yg-image-dot-trigger]');

          if (!trigger || !this.contains(trigger)) {
            return;
          }

          const activeGroup = trigger.closest('[data-yg-image-dot-group]');
          const activeSlide = activeGroup.closest('[data-yg-image-dot-slide]');
          const groups = activeSlide.querySelectorAll('[data-yg-image-dot-group]');
          const shouldCloseActiveGroup = activeGroup.classList.contains('is-active');

          groups.forEach((group) => {
            const shouldOpenGroup = group === activeGroup && !shouldCloseActiveGroup;
            group.classList.toggle('is-active', shouldOpenGroup);

            const card = group.querySelector('[data-yg-image-dot-card]');
            if (card && !shouldOpenGroup) {
              card.style.removeProperty('--yg-image-dot-card-offset-x');
            }

            const groupTrigger = group.querySelector('[data-yg-image-dot-trigger]');
            if (groupTrigger) {
              groupTrigger.setAttribute('aria-expanded', shouldOpenGroup ? 'true' : 'false');
            }
          });

          this.positionActiveCards();
        });

        window.addEventListener('resize', this.handleResize);
        this.bindSwiper();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
      }

      changeSlide(direction) {
        const swiper = this.getSwiper();

        if (swiper) {
          if (direction > 0) {
            swiper.slideNext();
          } else {
            swiper.slidePrev();
          }

          return;
        }

        const slides = Array.from(this.querySelectorAll('[data-yg-image-dot-slide]'));

        if (slides.length < 2) {
          return;
        }

        const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
        const nextIndex = (currentIndex + direction + slides.length) % slides.length;

        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === nextIndex);

          this.activateFirstGroup(slide);
        });

        this.updateCounter(nextIndex);
      }

      bindSwiper(retryCount = 0) {
        const swiper = this.getSwiper();

        if (!swiper) {
          if (retryCount < 20) {
            window.setTimeout(() => this.bindSwiper(retryCount + 1), 50);
          }

          return;
        }

        if (this.boundSwiper === swiper) {
          return;
        }

        this.boundSwiper = swiper;
        swiper.on('slideChange', () => this.syncSwiperState());
        this.syncSwiperState();
      }

      getSwiper() {
        return this.querySelector('[data-yg-image-dot-swiper]')?.swiper;
      }

      syncSwiperState() {
        const swiper = this.getSwiper();
        const slides = Array.from(this.querySelectorAll('[data-yg-image-dot-slide]'));
        const activeIndex = swiper ? swiper.realIndex ?? swiper.activeIndex : 0;

        slides.forEach((slide, index) => {
          slide.classList.toggle('is-active', index === activeIndex);
          this.activateFirstGroup(slide);
        });

        this.updateCounter(activeIndex);
        this.positionActiveCards();
      }

      activateFirstGroup(slide) {
        const groups = slide.querySelectorAll('[data-yg-image-dot-group]');

        groups.forEach((group, groupIndex) => {
          group.classList.toggle('is-active', groupIndex === 0);

          const card = group.querySelector('[data-yg-image-dot-card]');
          if (card && groupIndex !== 0) {
            card.style.removeProperty('--yg-image-dot-card-offset-x');
          }

          const trigger = group.querySelector('[data-yg-image-dot-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', groupIndex === 0 ? 'true' : 'false');
          }
        });
      }

      positionActiveCards() {
        if (!window.matchMedia('(max-width: 699px)').matches) {
          this.querySelectorAll('[data-yg-image-dot-card]').forEach((card) => {
            card.style.removeProperty('--yg-image-dot-card-offset-x');
          });
          return;
        }

        window.requestAnimationFrame(() => {
          const activeGroups = this.querySelectorAll('[data-yg-image-dot-group].is-active');

          activeGroups.forEach((group) => {
            const card = group.querySelector('[data-yg-image-dot-card]');
            if (!card) {
              return;
            }

            card.style.setProperty('--yg-image-dot-card-offset-x', '0px');

            const viewportPadding = 16;
            const cardRect = card.getBoundingClientRect();
            const minLeft = viewportPadding;
            const maxRight = window.innerWidth - viewportPadding;
            let offsetX = 0;

            if (cardRect.left < minLeft) {
              offsetX = minLeft - cardRect.left;
            } else if (cardRect.right > maxRight) {
              offsetX = maxRight - cardRect.right;
            }

            card.style.setProperty('--yg-image-dot-card-offset-x', `${Math.round(offsetX)}px`);
          });
        });
      }

      updateCounter(index) {
        const currentCounter = this.querySelector('[data-yg-image-dot-current]');
        if (currentCounter) {
          currentCounter.textContent = String(index + 1);
        }
      }
    }

    customElements.define('yg-image-dot-product', YGImageDotProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;

    constructor() {
      super();
      this.currentStepIndex = 0;
      this.initializeFirstStep = this.initializeFirstStep.bind(this);
      this.handleItemClick = this.handleItemClick.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
    }

    get $sectionEl() {
      if (this.#sectionEl) {
        return this.#sectionEl;
      }

      this.#sectionEl = {
        accordionList: Array.from(this.querySelectorAll('.yg-process-steps-item')),
        accordionButtons: Array.from(this.querySelectorAll('.yg-process-steps-item-button')),
        progressBars: Array.from(this.querySelectorAll('.yg-process-steps-progress-bar')),
        controls: Array.from(this.querySelectorAll('.yg-process-steps-media')),
        details: Array.from(this.querySelectorAll('.yg-process-steps-detail')),
      };

      return this.#sectionEl;
    }

    connectedCallback() {
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      this.$sectionEl.accordionButtons.forEach((button) => {
        button.addEventListener('click', this.handleItemClick);
      });
      this.initializeFirstStep();
    }

    disconnectedCallback() {
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
      this.$sectionEl.accordionButtons.forEach((button) => {
        button.removeEventListener('click', this.handleItemClick);
      });
      this.stopAllProgress();
      this.pauseAllVideos();
    }

    handleItemClick(event) {
      const item = event.currentTarget.closest('.yg-process-steps-item');
      const id = item?.getAttribute('data-id');
      if (id) {
        this.currentStep(id);
      }
    }

    handleProgressEnd(event) {
      if (event.detail.id) {
        this.nextStep(event.detail.id);
      }
    }

    initializeFirstStep() {
      const firstItem = this.$sectionEl.accordionList[0];
      if (!firstItem) {
        return;
      }

      const firstId = firstItem.getAttribute('data-id');
      if (firstId) {
        this.currentStep(firstId);
      }
    }

    nextStep(id) {
      if (!this.isCurrentStep(id) || this.$sectionEl.accordionList.length < 2) {
        return;
      }

      this.$sectionEl.accordionList.forEach((item, index) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = index === this.$sectionEl.accordionList.length - 1 ? 0 : index + 1;
        }
      });

      const nextId = this.$sectionEl.accordionList[this.currentStepIndex]?.getAttribute('data-id');
      if (nextId) {
        this.currentStep(nextId);
      }
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }

      this.setCurrentStepIndex(id);
      this.setActiveItem(id);
      this.setActiveDetail(id);
      this.setActiveControl(id);
      this.startProgressForId(id);
      this.playVideo(id);
    }

    isCurrentStep(id) {
      return this.$sectionEl.accordionList.some((item) => item.getAttribute('data-id') === id);
    }

    setCurrentStepIndex(id) {
      this.$sectionEl.accordionList.forEach((item, index) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = index;
        }
      });
    }

    setActiveItem(id) {
      this.$sectionEl.accordionList.forEach((item) => {
        const isActive = item.getAttribute('data-id') === id;
        item.classList.toggle('is-active', isActive);

        const button = item.querySelector('.yg-process-steps-item-button');
        if (button) {
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }

    setActiveDetail(id) {
      this.$sectionEl.details.forEach((item) => {
        item.classList.toggle('active', item.getAttribute('data-id') === id);
      });
    }

    setActiveControl(id) {
      this.$sectionEl.controls.forEach((item) => {
        item.classList.toggle('active', item.getAttribute('data-id') === id);
      });
    }

    startProgressForId(id) {
      this.$sectionEl.progressBars.forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    stopAllProgress() {
      this.$sectionEl.progressBars.forEach((item) => item.stopProgress());
    }

    getVideoById(id) {
      const currentControl = this.$sectionEl.controls.find((item) => item.getAttribute('data-id') === id);
      return currentControl?.querySelector('yg-video') || null;
    }

    pauseAllVideos() {
      this.$sectionEl.controls.forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (videoEl) {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id) {
      this.pauseAllVideos();
      const videoEl = this.getVideoById(id);
      if (videoEl) {
        videoEl.playVideo();
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();
})();
